export default {
  ADD: 1,
  EDIT: 2,
  APPROVE: 3,
  REPROVE: 4,
  VIEW: 5,
};
